import { ChangeEvent, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { HolidayAndWayOfWorkingListType } from 'types/kodawari';

/**
 * 休日・働き方に関するカスタムフック
 * @param initialHolidayAndWayOfWorkingList
 * @returns  休日・働き方の値と更新する関数を含むオブジェクト
 */
export const useHolidayAndWayOfWorking = (
  initialHolidayAndWayOfWorkingList: HolidayAndWayOfWorkingListType[]
) => {
  const [holidayAndWayOfWorkingList, setHolidayAndWayOfWorking] = useState<
    HolidayAndWayOfWorkingListType[]
  >(initialHolidayAndWayOfWorkingList);

  const selectedHolidayAndWayOfWorkingList = holidayAndWayOfWorkingList
    .filter(({ isChecked }) => isChecked)
    .map(({ value }) => value);

  // チェック状態更新処理
  const updateIsCheckedHolidayAndWayOfWorkingList = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const checkedList = holidayAndWayOfWorkingList.map((item) => {
      if (item.value !== event.target.value) return item;

      return {
        ...item,
        isChecked: event.target.checked,
      };
    });

    setHolidayAndWayOfWorking(checkedList);

    return checkedList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  };

  // 求人件数更新処理
  const updateHolidayAndWayOfWorkingListJobCount = (
    holidayAndWayOfWorkingJobCountList: JobCountDetailResponse[] | undefined
  ) => {
    setHolidayAndWayOfWorking((pre) =>
      pre.map((item) => ({
        ...item,
        jobCount: findJobCount(holidayAndWayOfWorkingJobCountList, item.value),
      }))
    );
  };

  // チェック状態クリア処理
  const clearIsCheckedHolidayAndWayOfWorkingList = () => {
    const checkedList = holidayAndWayOfWorkingList.map((item) => {
      return {
        ...item,
        isChecked: false,
      };
    });
    setHolidayAndWayOfWorking(checkedList);
  };

  return {
    holidayAndWayOfWorkingList,
    selectedHolidayAndWayOfWorkingList,
    updateIsCheckedHolidayAndWayOfWorkingList,
    updateHolidayAndWayOfWorkingListJobCount,
    clearIsCheckedHolidayAndWayOfWorkingList,
  };
};
